import { render } from "./shoppingIndex.vue?vue&type=template&id=cbf96d1c&scoped=true"
import script from "./shoppingIndex.vue?vue&type=script&lang=js"
export * from "./shoppingIndex.vue?vue&type=script&lang=js"

import "./shoppingIndex.vue?vue&type=style&index=0&id=cbf96d1c&scoped=true&lang=scss"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf96d1c"]])

export default __exports__